console.log('From list-history-n-images component!!!');

document.addEventListener("DOMContentLoaded", function() {
	const config = {
		"desktop": {
			perMove: 1,
			focus: 0, // 0 = left and 'center' = center
			type: 'slide', // 'loop' or 'slide'
			gap: '18px', // space between slides
			arrows: true, // 'slider' or false
			pagination: false, // 'slider' or false
			speed: 600, // transition speed in miliseconds
			dragAngleThreshold: 30, // default is 30
			autoWidth: false, // for cards with differing widths
			rewind: false, // go back to beginning when reach end
			rewindSpeed: 400,
			waitForTransition: false,
			updateOnMove: true,
			trimSpace: false, // true removes empty space from end of list
			// breakpoints: {
			// 	991: {
			// 		// Tablet
			// 		perPage: 3,
			// 		gap: '18px',
			// 	},
			// 	767: {
			// 		// Mobile Landscape
			// 		perPage: 2,
			// 		gap: '18px',
			// 	},
			// 	479: {
			// 		// Mobile Portrait
			// 		perPage: 1.5,
			// 		gap: '16px',
			// 	}
			// }
		},
		"mobile": {
			perPage: 1.5,
			perMove: 1,
			focus: 0, // 0 = left and 'center' = center
			type: 'slide', // 'loop' or 'slide'
			gap: '18px', // space between slides
			arrows: true, // 'slider' or false
			pagination: false, // 'slider' or false
			speed: 600, // transition speed in miliseconds
			dragAngleThreshold: 30, // default is 30
			autoWidth: false, // for cards with differing widths
			rewind: false, // go back to beginning when reach end
			rewindSpeed: 400,
			waitForTransition: false,
			updateOnMove: true,
			trimSpace: false, // true removes empty space from end of list
			mediaQuery: 'min',
			breakpoints: {
				768: {
					destroy: true,
				},
			}
		}
	};
	//Slider
	document.querySelectorAll('.splide-mobile').forEach((s) => {
		const splideM = new Splide(s, config.mobile);
		let bar = splideM.root.querySelector('.splide__progressbar');

		if(bar){
			// Update the bar width:
			splideM.on('mounted move', function () {
				const end = splideM.Components.Controller.getEnd() + 1;
				bar.style.width = String(100 * (splideM.index + 1) / end) + '%';
			});
		}
		
		splideM.mount();
	});

	document.querySelectorAll('.splide').forEach((s) => {
		// let slidesnum = 4;
		// const slidesattr = s.getAttribute('data-slides');
		const splideattr = s.getAttribute('data-splide');
		
		// if (slidesattr){
		// 	slidesnum = parseInt(slidesattr);
		// }

		let splide	= new Splide(s, Object.assign({}, config.desktop, splideattr));
		let bar		= splide.root.querySelector('.splide__progressbar');

		if(bar){
			// Update the bar width:
			splide.on('mounted move', function () {
				const end = splide.Components.Controller.getEnd() + 1;
				bar.style.width = String(100 * (splide.index + 1) / end) + '%';
			});
		}
		splide.mount();
	});
});